import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { getUserById, UpdateUser, getInterests } from "../api/api";
import "../UserProfileEdit/EditInterest.css";
import bgImage from "../../assets/images/brown-background.jpg";

const EditInterest = () => {
  const navigate = useNavigate();
  const [interests, setInterests] = useState([]);
  const [selectedInterest, setSelectedInterest] = useState([]);
  const [userdata, setUserdata] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const response = await getInterests();
        console.log("getInterest-api", response);
        if (response?.success) {
          setInterests(response.data);
        } else {
          Swal.fire("Error", "Failed to fetch interests", "error");
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
      }
    };

    fetchInterests();
  }, []);

  useEffect(() => {
    const getUserData = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("currentUser"));
        const _id = storedUser?.id || storedUser?._id;
        console.log("////////////", _id);

        if (_id) {
          const currentUser = await getUserById({ user_id: _id });
          console.log("get_user_by_id", currentUser);
          setUserdata(currentUser);

          if (currentUser?.data?.interest_id && interests.length > 0) {
            const matchedInterestIds = interests
              .filter((interest) =>
                currentUser.data.interest_id.includes(interest?.id)
              )
              .map((interest) => interest?.id);
            setSelectedInterest(matchedInterestIds);
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    getUserData();
  }, [interests]);

  const handleSelectInterest = (interestId) => {
    setSelectedInterest((prevSelected) => {
      if (!Array.isArray(prevSelected)) return [];
      return prevSelected.includes(interestId)
        ? prevSelected.filter((id) => id !== interestId)
        : [...prevSelected, interestId];
    });
  };

  const handleUpdate = async () => {
    if (selectedInterest.length === 0) {
      Swal.fire("Error", "Please select at least 1 interest.", "warning");
      return;
    }

    setIsLoading(true);
    const storedUser = JSON.parse(localStorage.getItem("currentUser"));
    const _id = storedUser?.id || storedUser?._id;

    const payload = {
      user_id: _id,
      interest_id: selectedInterest,
    };

    try {
      const response = await UpdateUser(payload);
      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: response?.message,
        }).then(() => navigate("/Sidebar/EditProfile"));
      } else {
        Swal.fire(
          "Error",
          response?.message || "Something went wrong",
          "error"
        );
      }
    } catch (err) {
      console.error("Update error:", err);
      Swal.fire("Error", "Something went wrong!", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="interest-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <h3>Select your interests to match with similar users</h3>
      <div className="interests-box">
        {interests.map((interest) => (
          <button
            key={interest.id}
            className={`interest-btn ${
              selectedInterest.includes(interest.id) ? "selected" : ""
            }`}
            onClick={() => handleSelectInterest(interest.id)}
          >
            {interest.name}
          </button>
        ))}
      </div>

      <div className="button-group">
        <button
          className="btn cancel-btn"
          onClick={() => navigate("/Sidebar/EditProfile")}
        >
          Back
        </button>
        <button
          className="btn update-btn"
          onClick={handleUpdate}
          disabled={isLoading}
        >
          {isLoading ? "Updating..." : "Update"}
        </button>
      </div>
    </div>
  );
};

export default EditInterest;
